// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"161":"fdb9f2657f6d150eacc5","448":"9830649a74e0af708dcd","897":"1f4d9b6478084cf239f6"}[chunkId] + ".bundle.js";
};